import { ContentState, convertToRaw } from 'draft-js';
import createEmptyOptionCollection from './createEmptyOptionCollection';

export default (length, text) =>
  createEmptyOptionCollection(length, text).map(item => ({
    ...item,
    content: convertToRaw(ContentState.createFromText(item.value || 'Option')),
  }));
